import {Route, Routes} from '@angular/router';
import { environment } from '../environments/environment';
import { LandingListComponent } from './pages/landing-list/landing-list.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { LandingService } from './common/services/landing.service';

export const routes: Routes = [
  { path: '', loadChildren: () => import('./landings/gpl/gpl.routes').then(r => r.routes)},
  { path: '**', component: NotFoundComponent },
]

export function generateRoutes(landingService: LandingService): Routes {
  const landing = landingService.getLanding();

  const landingModules = {
    'gpl': () => import('./landings/gpl/gpl.routes').then(r => r.routes),
    'test': () => import('./landings/test/test.routes').then(r => r.routes),
  };

  const routes: Routes = [];

  routes.push(
    { path: '', component: LandingListComponent, pathMatch: 'full' },
    {
      path: 'gpl',
      loadChildren: landingModules['gpl'],
    },
    {
      path: 'test',
      loadChildren: landingModules['test'],
    },
    { path: '**', component: NotFoundComponent },
  );

  return routes;
}
